import {
    getOutputComments,
    setOutputError,
    insertOutputComments,
    resetOutputComments
} from "../../../../constants/model-reducers/external/recharge/output-configuration/output-configuration-comments.settings";
import { httpGet, httpPost, httpPostFile, httpDownload } from "../../../../utils/api.utils";

const defaultState = () => ({
    outputComments: [],
    pageIndex: 1,
    hasMoreComments: true
});

const initialState = defaultState();

export const outputCommentActions = {
    postOutputComments: (RechargingOutputConfigurationId, fileName, fileData, comment) => async (dispatch, state) => {
        var formData = new FormData();

        if (fileData.length > 0) {
            fileData.forEach((element) => formData.append("FileData", element));
            formData.append("FileName", JSON.stringify(fileName));
        }

        formData.append("Comment", comment.toString());
        formData.append("UserId", parseInt(sessionStorage.getItem('UserID')));
        formData.append("RechargingOutputConfigurationId", RechargingOutputConfigurationId);

        var res = await httpPostFile('external/recharge/setOutputComments', formData);

        if (res != null) {
            dispatch({
                type: insertOutputComments, 
                outputComments: res.outputComments,
                isOutputCommentLoaded: true,
                isOutputCommentError: false
            });
        } else {
            dispatch({
                type: setOutputError,
                isOutputCommentError: true,
                isOutputCommentLoaded: false
            });
        }
    },


    getOutputComments: (RechargingOutputConfigurationId, pageIndex = 1, pageSize = 5) => async (dispatch, state) => {
        const { outputComments } = state().outputComment;

        const existingComments = outputComments || [];
        const lastCommentId =
            existingComments.length > 0
                ? existingComments[existingComments.length - 1].CommentID
                : null;

        const res = await httpGet(
            `external/recharge/getOutputComments/${pageIndex}/${pageSize}?RechargingOutputConfigurationId=${RechargingOutputConfigurationId}` +
            (lastCommentId != null ? `&lastCommentId=${lastCommentId}` : "")
        );

        if (res != null) {
            dispatch({
                type: getOutputComments,
                outputComments: res.outputComments,
                isOutputCommentLoaded: true,
                isOutputCommentError: false,
                pageIndex: pageIndex,
                hasMoreData: res.hasMoreData
            });
        } else {
            dispatch({
                type: setOutputError,
                isOutputCommentError: true,
                isOutputCommentLoaded: false
            });
        }
    },

    deleteOutputComments: (commentId) => async (dispatch, state) => {
        var userId = sessionStorage.getItem("UserID");
        var res = await httpPost('external/recharge/outputDeleteComment/' + commentId + '/' + userId);

        if (res == null) {
            dispatch({
                type: setOutputError,
                isOutputCommentError: true,
                isOutputCommentLoaded: false
            });
        }
    },

    resetOutputComments: () => (dispatch) => {
        dispatch({
            type: resetOutputComments,
        })
    },
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getOutputComments: {
            return {
                ...state,
                outputComments: [
                    ...state.outputComments,
                    ...action.outputComments
                ],
                hasMoreComments: action.hasMoreData,
                pageIndex: action.pageIndex
            };
        }
        case setOutputError: {
            return {
                ...state,
                isOutputCommentError: action.isOutputCommentError,
                isOutputCommentLoaded: action.isOutputCommentLoaded
            }
        }
        case insertOutputComments: {
            const combinedComments = [
                ...action.outputComments,
                ...state.outputComments
            ];

            const currentVisibleCount = state.outputComments.length;
            const currentDisplayLimit = Math.ceil(currentVisibleCount / 5) * 5;
            const hasMore =
                combinedComments.length > currentDisplayLimit &&
                combinedComments.length !== 1;

            let updatedComments;
            if (hasMore) {
                updatedComments = combinedComments.slice(0, -1);
            } else {
                updatedComments = combinedComments;
            }

            return {
                ...state,
                outputComments:
                    combinedComments.length === 1
                        ? action.outputComments
                        : updatedComments,
                hasMoreComments: hasMore,
            };
        }
        case resetOutputComments:
            return {
                ...state,
                outputComments: [],
                hasMoreComments: false,
                pageIndex: 1
            }
        default:
            return state;
    }
}